import { render, staticRenderFns } from "./SubMenuLayerErosion.vue?vue&type=template&id=0ebac48a&scoped=true"
import script from "./SubMenuLayerErosion.vue?vue&type=script&lang=js"
export * from "./SubMenuLayerErosion.vue?vue&type=script&lang=js"
import style0 from "./SubMenuLayerErosion.vue?vue&type=style&index=0&id=0ebac48a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ebac48a",
  null
  
)

export default component.exports